import { combineReducers } from '@reduxjs/toolkit';

import softwareRenewal from 'software_renewal/redux/slice';

const rootReducer = combineReducers({
  softwareRenewal,
});

export default rootReducer;
